import React from "react";
import Flickity from "react-flickity-component";
import "flickity/css/flickity.css";
import Titre from "../common/Titre";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

export default function PartenaireList() {
  const flickityOptions = {
    initialIndex: 0,
    cellAlign: "left",
    contain: true,
    pageDots: false,
    freeScroll: false,
    wrapAround: false,
    autoPlay: false,
    prevNextButtons: true,
  };
  const partenaires = [
    {
      id: 1,
      logo: "https://th.bing.com/th/id/OIP.pPmc7amyUKu-DKo6NOl-3wHaGJ?rs=1&pid=ImgDetMain",
    },
    // {
    //   id: 2,
    //   logo: "https://lafactory.ma/wp-content/uploads/2019/01/universite-de-montreal-2-1.jpg",
    // },
    {
      id: 3,
      logo: "https://th.bing.com/th/id/OIP.Wz6RFFvcsoFu_VvV5ik6XQAAAA?rs=1&pid=ImgDetMain",
    },
    {
      id: 4,
      logo: "https://www.kanadakulturmerkezi.com/wp-content/uploads/2018/12/1200px-Niagara-college_vectorized.svg_.png",
    },
    {
      id: 5,
      logo: "https://th.bing.com/th/id/R.aa4c304162dedbf04a59310def6d2a24?rik=8RQeOvfFb0AB%2fw&riu=http%3a%2f%2fwww.epiccollege.ca%2fwp-content%2fuploads%2f2021%2f05%2flogosmall4.png&ehk=63NRw3st9RfNbi6ZDXj3D6fofl%2fnXA%2fZoL6RSWpfIZ8%3d&risl=&pid=ImgRaw&r=0",
    },
    {
      id: 6,
      logo: "https://tukuz.com/wp-content/uploads/2020/10/centennial-college-logo-vector.png",
    },
    {
      id: 7,
      logo: "https://assets-global.website-files.com/62aa6a0ad689e34226f97321/63aef52c0c218af53825497f_images.jpeg",
    },
    {
      id: 8,
      logo: "https://logos-download.com/wp-content/uploads/2018/06/Canada_College_logo_cercle.png",
    },
    {
      id: 9,
      logo: "https://studyonline.ca/wp-content/uploads/2022/08/college-boreal-logo.jpg",
    },
    {
      id: 10,
      logo: "https://www.wemakescholars.com/admin/uploads/providers/paIGvMX-vKiZNllbV1I4u76djKXzi-cj.png",
    },
  ];

  return (
    <>
      {" "}
      <Titre
        children={"Ils nous ont fait confiance"}
        icon={faGraduationCap}
        soustitre={"Ils nous ont fait confiance"}
      />
      <Flickity className="carousel" options={flickityOptions}>
        {partenaires.map((partenaire) => (
          <div key={partenaire.id} className="carousel-cell">
            <img src={partenaire.logo} alt={`Partenaire ${partenaire.id}`} />
          </div>
        ))}
      </Flickity>
    </>
  );
}
